<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header" v-if="!modal" >Información del Tipo de Presupuesto</div>
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      v-if= "!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tipoPresupuesto/getField',
  mutationType: 'tipoPresupuesto/updateField',
});

export default {
  name: 'TipoPresupuestoABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    tipoPresupuestoId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',

      tableBusy: false,
      labelCols: 2,
      inicializando: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'inactivo',
    ])
  },  
  created() {
    let tipoPresupuestoId = 0;

    if (!this.modal) {
      if (this.$route.params){
        if (this.$route.params.id){
          tipoPresupuestoId = this.$route.params.id;
        }
      }
    }

    if (this.modal) {
      if (this.tipoPresupuestoId) {
        if (this.tipoPresupuestoId != 0) {
          tipoPresupuestoId = this.tipoPresupuestoId;
        }
      }
    }

    this.showSpinner();
    this.$store.dispatch('tipoPresupuesto/inicializar', tipoPresupuestoId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del tipo de presupuesto.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('tipoPresupuesto/save')
            .then(()  => {
              if (!this.modal) {
                this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light');
              } else {
                this.$emit('updateTipoPresupuesto', 
                  this.$store.getters['tipoPresupuesto/tipoPresupuesto']);
              }
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      } 
    },
    goBack() {
      if (!this.modal) {
        this.$router.go(-1);
      } else {
        this.$emit('closeTipoPresupuesto');
      }
    },
    goList() {
      this.$router.push({ name: "TiposPresupuestos" });
    },
  },
  watch: {
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
